import queryString from 'query-string';
import { httpwmsapi } from 'src/services';

export const Types = {
  APPROVE_SCHEDULE_RECEIVING_LOADING: 'approveScheduleReceiving/loading',
  APPROVE_SCHEDULE_RECEIVING_SET_DATA: 'approveScheduleReceiving/set/data',
  APPROVE_SCHEDULE_RECEIVING_SET_PAGING: 'approveScheduleReceiving/set/paging',
  APPROVE_SCHEDULE_RECEIVING_SET_FILTER: 'approveScheduleReceiving/set/filter',
  APPROVE_SCHEDULE_RECEIVING_SET_FILTER_CHIP: 'approveScheduleReceiving/set/filter_chip',
};

const initialState = {
  loading: false,
  approve_schedule_receiving: [],
  approve_schedule_receiving_paging: { limit: 25, offset: 0, total: 0 },
  approve_schedule_receiving_filters: [],
  approve_schedule_receiving_filters_chip: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.APPROVE_SCHEDULE_RECEIVING_LOADING:
      return { ...state, loading: action.payload };
    case Types.APPROVE_SCHEDULE_RECEIVING_SET_DATA:
      return { ...state, approve_schedule_receiving: action.payload };
    case Types.APPROVE_SCHEDULE_RECEIVING_SET_PAGING:
      return { ...state, approve_schedule_receiving_paging: action.payload };
    case Types.APPROVE_SCHEDULE_RECEIVING_SET_FILTER:
      return { ...state, approve_schedule_receiving_filters: action.payload };
    case Types.APPROVE_SCHEDULE_RECEIVING_SET_FILTER_CHIP:
      return {
        ...state,
        approve_schedule_receiving_filters_chip: action.payload,
      };
    default:
      return state;
  }
}

export const Creators = {
  approveScheduleReceivingLoading: (value) => ({
    type: Types.APPROVE_SCHEDULE_RECEIVING_LOADING,
    payload: value,
  }),
  approveScheduleReceivingSetData: (value) => ({
    type: Types.APPROVE_SCHEDULE_RECEIVING_SET_DATA,
    payload: value,
  }),
  approveScheduleReceivingSetPaging: (value) => ({
    type: Types.APPROVE_SCHEDULE_RECEIVING_SET_PAGING,
    payload: value,
  }),
  approveScheduleReceivingSetFilter: (value) => ({
    type: Types.APPROVE_SCHEDULE_RECEIVING_SET_FILTER,
    payload: value,
  }),
  approveScheduleReceivingSetFilterChip: (value) => ({
    type: Types.APPROVE_SCHEDULE_RECEIVING_SET_FILTER_CHIP,
    payload: value,
  }),

  getApproveScheduleReceiving: (filters = {}) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' }).replaceAll('%5B', '[').replaceAll('%5D', ']');
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/recebimento-agend/lista-aprovacao-agendamento?${qry}`, {
          timeout: 1000 * 60,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  approveOrReScheduleReceiving: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/recebimento-agend/aprova-ou-reagenda-agendamento`, body, {
          timeout: 1000 * 60,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
};
